import logo from './logo.svg';
import './App.css';
import Routers from './Router';

function App() {
  return (
<>
<Routers/>
</>
  );
}

export default App;
